const { REACT_APP_API_URL_CHECKOUT } = process.env;
export const environment = {
    production: false,
    graphqlUri: `${REACT_APP_API_URL_CHECKOUT}`
};
  